/**
 * Single source of truth for the storageType/storageTypes invariant.
 * `storageTypes` is authoritative; `storageType` is the legacy scalar mirror
 * kept synced to `storageTypes[0]`.
 */
export function storageTypeFields(input: {
  storageType?: string | null;
  storageTypes?: string[] | null;
}): { storageType: string | null; storageTypes: string[] } {
  let storageTypes: string[] = [];
  if (input.storageTypes?.length) {
    storageTypes = input.storageTypes;
  } else if (input.storageType) {
    storageTypes = [input.storageType];
  }
  return { storageType: storageTypes[0] ?? null, storageTypes };
}
